<template lang="pug">
.referrals
    submenu
        referrals-submenu
    .content
        page-header
            h1.highlight Referrals
        template(v-if="!$apollo.loading")
            page(v-if="!referralsFiltered.length")
                empty No referrals found
            el-table(v-else, :data='referralsFiltered', @row-click='navigateToReferral')
                el-table-column(property="status", label="Status", width="170")
                    template(slot-scope="scope")
                        el-tag(size="small", :type="referralStatus(scope.row.status)") {{ scope.row.status | capitalise }}
                el-table-column(property='School.name', label='School Name', :show-overflow-tooltip="true", width='400')
                    template(slot-scope="scope")
                        strong {{ scope.row.School.name }}
                el-table-column(property='Company.name', label='Company')
                el-table-column(property='School.id', label='School ID')
                el-table-column(property='School.establishment_number', label='Est', align='center')
                el-table-column(property='School.la_code', label='LA', align='center')
                el-table-column(property='School.urn', label='URN', align='center')
                el-table-column(property='School.Mis.nice_name', label='Mis', align='center')
                el-table-column(property="state", label="State", align='center')
                    template(slot-scope="scope")
                        el-tag(size="small", :type="referralState(scope.row.state)") {{ scope.row.state }}
</template>

<script>
import ReferralsSubmenu from "@/views/referrals/ReferralsSubmenu.vue";
import gql from "graphql-tag";

export default {
	components: {
		ReferralsSubmenu
	},
	computed: {
		referralsFiltered() {
			if (!this.Referrals) return [];

			if (this.Referrals && this.$route.query.status) {
				return this.Referrals.filter(r => r.status == this.$route.query.status);
			}

			return this.Referrals;
		}
	},
	apollo: {
		Referrals: {
			query: gql`
				query Referrals {
					Referrals {
						id
						created_at
						School {
							id
							name
							establishment_number
							la_code
							urn
							Mis {
								nice_name
							}
						}
						Company {
							name
						}
						state
						status
					}
				}
			`,
			fetchPolicy: "cache-and-network"
		}
	},
	methods: {
		referralState(state) {
			let tag = "info";
			switch (state) {
				case "issue":
					tag = "warning";
					break;
				case "blocked":
					tag = "danger";
					break;
			}
			return tag;
		},
		referralStatus(status) {
			let tag = "info";
			switch (status) {
				case "new":
					tag = "info";
					break;
				case "pending":
					tag = "error";
					break;
				case "responded":
					tag = "success";
					break;
			}
			return tag;
		},
		navigateToReferral(referral) {
			this.$router.push({ name: "referrals.show", params: { referral: referral.id } });
		}
	}
};
</script>
